import React, { useEffect, useState } from 'react';
import type { PartnerAsset } from '../../types/partners';
type PartnerImageProps = {
  asset: PartnerAsset;
  className?: string;
  /** Rendered when the file is missing or fails to load. Never a generated image. */
  fallback: React.ReactNode;
  eager?: boolean;
  onAvailabilityChange?: (available: boolean) => void;
};

/** Partner-supplied image with intrinsic size (no layout shift), lazy loading and a graceful fallback. */
export function PartnerImage({
  asset,
  className,
  fallback,
  eager = false,
  onAvailabilityChange
}: PartnerImageProps) {
  const [failed, setFailed] = useState(!asset.src);
  useEffect(() => setFailed(!asset.src), [asset.src]);
  useEffect(() => onAvailabilityChange?.(!failed), [failed, onAvailabilityChange]);
  if (failed) return <>{fallback}</>;
  return <img src={asset.src} alt={asset.alt} width={asset.width} height={asset.height} loading={eager ? 'eager' : 'lazy'} decoding="async" onError={() => setFailed(true)} className={className} data-id="element-950" data-mp="3hl3pt2bsu2b7" />;
}